<template>
  <div>
    <template v-if="hasMsg">
      <gj-tooltip
          width-auto
          :text-line="1">
        <template v-if="hasBudgetDailiesMsg">
          <div v-html="strategyHtml('budgetDailies')"></div>
        </template>
        <template v-else>
          <div v-html="strategyHtml('dailyBudget')"></div>
        </template>
        <template #content>
          <div v-if="hasBudgetDailiesMsg" style="line-height: 20px;">
            <div v-for="(item, i) in data('budgetDailies')"
                 :key="i">
              <div v-for="(jtem, j) in item.data"
                   :key="j">
                <span class="week-set-text">
                  <template v-if="j === 0">{{item.week | optionText(AdStrategyEnum.repeatOption)}}：</template>
                </span>
                <span>{{ strategy(jtem, 'budgetDailies') }}</span>
              </div>
            </div>
          </div>
          <div v-else>
            <span>{{ strategy(item.templateExpressionValue.dailyBudget.expression, 'dailyBudget') }}</span>
          </div>
        </template>
      </gj-tooltip>
    </template>
    <template v-else>-</template>
  </div>
</template>

<script>
  import {isMeaningfulMixin} from "../../../../../../minxins";
  import {isMeaningful} from "../../../../../../utils/common";
  import {AdStrategyEnum} from "../../common/enum";
  import {convertToDate, convertToFullDate} from "../../../../../../utils/date.util";
  import {optionText} from "../../../../../../filters";

  export default {
    name: "app-budget-strategy-set-info",
    mixins: [isMeaningfulMixin],
    props: {
      item: {
        required: true
      }
    },
    data() {
      return {
        AdStrategyEnum: AdStrategyEnum
      };
    },
    computed: {
      hasMsg() {
        return this.hasBudgetDailiesMsg || this.hasDailyBudgetMsg;
      },
      hasBudgetDailiesMsg() {
        if (isMeaningful(this.item.templateExpressionValue)
          && isMeaningful(this.item.templateExpressionValue.budgetDailies)
          && this.item.templateExpressionValue.budgetDailies.allowUsed
          && isMeaningful(this.item.templateExpressionValue.budgetDailies.expression)
          && this.item.templateExpressionValue.budgetDailies.expression.length > 0) {
          return true;
        }
        return false;
      },
      hasDailyBudgetMsg() {
        if (isMeaningful(this.item.templateExpressionValue)
          && isMeaningful(this.item.templateExpressionValue.dailyBudget)
          && this.item.templateExpressionValue.dailyBudget.allowUsed
          && isMeaningful(this.item.templateExpressionValue.dailyBudget.expression)) {
          return true;
        }
        return false;
      }
    },
    methods: {
      strategy(data, type) {
        if (type === 'budgetDailies') {
          const startHour = `${data.startHour}:00`
          const endHour = `${data.endHour}:00`
          let budgetTypeText = '';
          if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD) {
            budgetTypeText = `增加${data.value}% ${data.max ? '最多调整 ' + data.max : ''}`;
          } else if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB) {
            budgetTypeText = `减少${data.value}% ${data.max ? '最低调整到 ' + data.max: ''}`;
          } else if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.VALUE_ADD) {
            budgetTypeText = `提高${data.value}`;
          } else if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.VALUE_SUB) {
            budgetTypeText = `降低${data.value}`;
          } else if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.VALUE_FIXED) {
            budgetTypeText = `直接设置为${data.value}`;
          }
          return `${startHour} 至 ${endHour} 预算 ${budgetTypeText}`;
        } else if (type === 'dailyBudget') {
          let budgetTypeText = '';
          if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD) {
            budgetTypeText = `增加${data.value}% ${data.max ? '最多调整 ' + data.max : ''}`;
          } else if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB) {
            budgetTypeText = `减少${data.value}% ${data.max ? '最低调整到 ' + data.max: ''}`;
          } else if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.VALUE_ADD) {
            budgetTypeText = `提高${data.value}`;
          } else if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.VALUE_SUB) {
            budgetTypeText = `降低${data.value}`;
          } else if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.VALUE_FIXED) {
            budgetTypeText = `直接设置为${data.value}`;
          }
          return `超出每日预算时，${budgetTypeText}，次日00:00自动恢复到原预算`;
        } else {
          return '-';
        }
      },
      data(type) {
        const data = [];
        let budgetDailies = this.item.templateExpressionValue[type].expression;
        if (type === 'dailyBudget') {
          budgetDailies = [budgetDailies];
        }
        if (this.hasMsg) {
          const dateList = this._.flatMap(budgetDailies, (item) => {
            return (item.dateList || []).map(date => ({
              ...item,
              date,
            }));
          });
          // { 1: [{}, {}] }
          const dateObj = this._.groupBy(dateList, 'date');
          this._.forIn(dateObj, (value, key) => {
            data.push({
              week: Number(key),
              data: this._.sortBy(value, 'startHour')
            });
          });
        }
        return this._.sortBy(data, item => item.week);
      },
      strategyHtml(type) {
        if (!this.hasMsg) {
          return '-';
        }
        if (type === 'budgetDailies') {
          return this.data(type).map((item, i) => {
            return `${optionText(item.week, AdStrategyEnum.repeatOption)}：${item.data.map(jtem => this.strategy(jtem, 'budgetDailies')).join('；')}`
          }).join('<br />');
        } else if (type === 'dailyBudget') {
          return this.strategy(this.item.templateExpressionValue.dailyBudget.expression, 'dailyBudget');
        } else {
          return '-';
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "common";
</style>
























